import { createFileRoute } from '@tanstack/react-router'
import { RecurringDetailPage } from '../../../../../features/finance/recurring-pages'

export const Route = createFileRoute('/_app/expenses/recurring/$recurringId/')({
  component: RecurringDetailPage,
})
